var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightbulbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#84D5DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 15.75C22.0156 15.75 20 17.8125 20 20.25C20 20.6719 20.3281 21 20.75 21C21.125 21 21.5 20.6719 21.5 20.25C21.5 18.6094 22.8125 17.25 24.5 17.25C24.875 17.25 25.25 16.9219 25.25 16.5C25.25 16.125 24.875 15.75 24.5 15.75ZM20.75 33.5625C20.75 33.7031 20.75 33.8438 20.8438 33.9844L22.0156 35.6719C22.1562 35.9062 22.3906 36 22.625 36H26.3281C26.5625 36 26.7969 35.9062 26.9375 35.6719L28.1094 33.9844C28.1562 33.8438 28.2031 33.7031 28.2031 33.5625V31.5H20.75V33.5625ZM24.5 12C19.6719 12 16.25 15.8906 16.25 20.25C16.25 22.3594 17 24.2344 18.2656 25.6875C19.0625 26.5781 20.2812 28.4531 20.7031 30H22.9531C22.9531 29.8125 22.9531 29.5781 22.8594 29.3438C22.625 28.5 21.8281 26.3438 19.9531 24.2344C19.0156 23.1094 18.5 21.7031 18.5 20.25C18.4531 16.8281 21.2656 14.25 24.5 14.25C27.7812 14.25 30.5 16.9688 30.5 20.25C30.5 21.7031 29.9375 23.1094 29 24.2344C27.1719 26.2969 26.3281 28.5 26.0938 29.3438C26 29.5781 26 29.7656 26 30H28.25C28.6719 28.4531 29.8906 26.5781 30.6875 25.6875C31.9531 24.2344 32.75 22.3594 32.75 20.25C32.75 15.7031 29.0469 12 24.5 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulbIcon);
export default __webpack_public_path__ + "static/media/lightbulb_icon.295fb8e479155f262e89ae20587672a1.svg";
export { ForwardRef as ReactComponent };